import React from 'react';

import ConnectionPageLayout from '../../../components/ConnectionPageLayout';
import ConnectionFinishedDesktop from '../ConnectionFinished/ConnectionFinishedDesktop';
import ConnectionPageContent from './ConnectionPageContent';

const ConnectionPageDesktop = ({currentStep, steps, isConnectionFinished, onOpenQsg, deviceType}) => {
    return (
        <ConnectionPageLayout>
            <div className='flex max-w-[570px] flex-1 flex-col items-center justify-center px-8 py-10 text-center'>
                {isConnectionFinished ? (
                    <ConnectionFinishedDesktop onOpenQsg={onOpenQsg} deviceType={deviceType} />
                ) : (
                    <ConnectionPageContent
                        currentStep={currentStep}
                        steps={steps}
                        onOpenQsg={onOpenQsg}
                        deviceType={deviceType}
                    />
                )}
            </div>
        </ConnectionPageLayout>
    );
};

export default ConnectionPageDesktop;
